import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBaseFormStore } from '../form-base-form/form-base-form.store';
import { FormBaseFormComponent, FormItem } from '../form-base-form/form-base-form.component';
import { FormSetEnum } from '../../../../../../../../../types/src/services/enum/form-set.enum';
import { niKeys } from '@libs/shared/form-helpers/forms/forms-json-keys';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectInputComponent } from '../../../../../../components/kit/input/select-input/select-input.component';
import {
    TextAreaInputComponent,
} from '../../../../../../components/kit/input/text-area-input/text-area-input.component';
import { FormatPersonPipe } from '../../../../../shared/pipes/format-person.pipe';
import { DateInputComponent } from '../../../../../../components/kit/input/date-input/date-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-form-ni-form',
    templateUrl: './form-ni-form.component.html',
    styleUrls: ['../form-base-form/form-base-form.scss'],
    providers: [FormBaseFormStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslatePipe,
        SelectInputComponent,
        TextAreaInputComponent,
        FormatPersonPipe,
        DateInputComponent,
        ActionButtonsComponent,
    ],
})
export class FormNiFormComponent extends FormBaseFormComponent implements OnInit {

    constructor() {
        super();

        this.formUniqueIdentifier = FormSetEnum.NI;
        this.keys = niKeys;

        const formConfig: FormItem[] = this.keys.map((key) => (
            { name: key, defaultValue: key !== 'orientation' ? 0 : 5, required: false }
        ));
        formConfig.push({ name: 'note', defaultValue: null, required: false });
        this.generateForm(formConfig, true);

        for (let i = 15; i >= 0; i -= 5) this.options.push({ value: i, name: i.toString() });
    }

    override ngOnInit() {
        super.ngOnInit();
        if (!this.folderFormData) {
            this.generateFinalEvaluation({});
        }
    }
}
